import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter as Router } from "connected-react-router";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { QueryClientProvider } from "@tanstack/react-query";
import { Helmet } from "react-helmet";

import "typeface-roboto";

import history from "../../redux/history";
import store from "../../redux";
import theme from "../../theme";
import AppComp from "./AppComp";
import { queryClient } from "../../shared/queryClient";

const { REACT_APP_VERSION, REACT_APP_BUILD_VERSION } = process.env;

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <>
              {(REACT_APP_VERSION || REACT_APP_BUILD_VERSION) && (
                <Helmet>
                  {REACT_APP_VERSION && (
                    <meta name="version" content={REACT_APP_VERSION} />
                  )}
                  {REACT_APP_BUILD_VERSION && (
                    <meta name="build" content={REACT_APP_BUILD_VERSION} />
                  )}
                </Helmet>
              )}
              <AppComp />
            </>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </Router>
    </QueryClientProvider>
  </Provider>
);

export default App;
